import FreeSpinReel  from "./FreeSpinReel"
import FreeSpinCell from "./FreeSpinCell";

export default class FreeSpinReelStatic extends FreeSpinReel {

    constructor(scene: any, x: number, y: number, index: number, freeSpinCellCreation: {cells: FreeSpinCell[]; cellPositions: any[]}) {
        super(scene, x, y, index, freeSpinCellCreation)
    }
}
